/**
 * Tiny typed pub/sub event bus exposed under `theme.pubsub`.
 *
 * Why: 35+ ad-hoc CustomEvents dispatched on document/element today, no central
 * registry, no contract. This bus replaces those with a typed EVENTS map and
 * gives BaseElement.subscribe auto-cleanup on disconnect.
 *
 * Doc: docs/decisions/ADR-0003-pubsub-event-bus.md
 */

window.theme = window.theme || {};

theme.pubsub = (() => {
  const EVENTS = Object.freeze({
    cartUpdate: 'cart-update',
    cartError: 'cart-error',
    variantChange: 'variant-change',
    optionValueChange: 'option-value-change',
    quantityUpdate: 'quantity-update',
    sectionRefreshed: 'section-refreshed',
    breakpointChange: 'breakpoint-change',
    debouncedResize: 'debounced-resize',
  });

  const subs = Object.create(null);

  /**
   * Publishes an event with optional data. Subscriber errors are caught and logged
   * so one bad subscriber cannot break the rest.
   * @param {string} event
   * @param {*} [data]
   */
  function publish(event, data) {
    const list = subs[event];
    if (!list || list.length === 0) return;
    // Iterate over a copy so subscribers can self-unsubscribe during dispatch
    list.slice().forEach((cb) => {
      try {
        cb(data);
      } catch (e) {
        console.error(`pubsub:${event}`, e);
      }
    });
  }

  /**
   * Subscribes a callback to an event. Returns an unsubscribe function.
   * @param {string} event
   * @param {Function} cb
   * @returns {Function}
   */
  function subscribe(event, cb) {
    if (!subs[event]) subs[event] = [];
    subs[event].push(cb);
    return () => {
      const list = subs[event];
      if (!list) return;
      const i = list.indexOf(cb);
      if (i !== -1) list.splice(i, 1);
    };
  }

  return { EVENTS, publish, subscribe };
})();
